
































import Vue from 'vue';

import Brand from '@/services/Brand';

export default Vue.extend({
	name: 'LoginBase',
	props: {
		heading: {
			type: String,
			required: false,
			default: 'Need help signing in?',
		},
	},
	computed: {
		details() {
			return Brand.getBrandInformation();
		},
	},
});
